angular.module('impactx.dashboard').controller('DashboardDelegationsCtrl', ['$scope', 'dataGen', '$mdDialog', '$context', '$securityManager', 'LoginService', '$redirect', DashboardDelegationsCtrl]);

function DashboardDelegationsCtrl($scope, dataGen, $mdDialog, $context, $securityManager, LoginService, $redirect) {

    dataGen.getData($scope, {}, "/dashboard/delegations").then(function (){
        $scope.isHidden.value = $scope.data.delegatesList && $scope.data.delegatesList.length === 0;
    })

    $scope.limit = $scope.height * 2;

    $scope.reLogin = function(user)
    {
        if (!user.isLoggedIn && !user.disabled)
        {
            var dataObj = {
                delegateUserId: user.userId
            };
            dataGen.postAsForm($scope, dataObj, "/delegation/delegatelogin").then(function ()
            {
                $securityManager.invalidateProcesses();
                LoginService.refreshUI(true);
            });
        }
    };

    $scope.redirectToAllDelegations = function()
    {
        $redirect.redirectTo(null, "/delegationlogin");
    };
}